import apiLogin from './modules/login'

export default {
    apiLogin
}